export var uuidToId = function uuidToId(uuid) {
  return uuid.replace(/-/g, '');
};